import { LinkNode } from '@lexical/link';
import { ParagraphNode } from 'lexical';
// Pasted link nodes can contain paragraphs, so we need to clean them up else input ends up in an invalid state.
export const paragraphNodeTransform = (editor) => editor.registerNodeTransform(ParagraphNode, (paragraphNode) => {
    // Strip block alignment/indent imported from pasted HTML (e.g. `text-align: center`
    // or `justify`). Lexical's ParagraphNode DOM importer copies these onto the element
    // format, which would otherwise render and serialize, leaving the single-line input
    // centered/justified instead of left-aligned. The guards keep the transform converging,
    // mirroring the TextNode format reset above.
    if (paragraphNode.getFormatType() !== '') {
        paragraphNode.setFormat('');
    }
    if (paragraphNode.getIndent() !== 0) {
        paragraphNode.setIndent(0);
    }
    const parent = paragraphNode.getParent();
    if (parent instanceof LinkNode) {
        const nodes = paragraphNode.getChildren();
        nodes.forEach((node) => {
            parent.append(node);
        });
        paragraphNode.remove();
    }
});
//# sourceMappingURL=paragraphNodeTransform.js.map